import DOMPurify from 'isomorphic-dompurify';
import { isNil } from 'lodash';

export const safelyExtractTextFromHTML = (input: string | undefined | null): string => {
  if (isNil(input)) {
    return '';
  }

  return DOMPurify.sanitize(input, {
    ALLOWED_TAGS: [],
    KEEP_CONTENT: true,
  }).trim();
};
